import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { initializeTracking } from './services/visitorTracking';
import { trackWilayaVisit } from './services/wilayaTracking';
import RouteTracker from './components/RouteTracker';
import HomeScreen from './components/HomeScreen';
import OrdersPage from './components/OrdersPage';
import AdminHomeScreen  from './components/AdminHomeScreen';
import CategoryScreen   from './components/CategoryScreen';
import AddGuppyScreen    from './components/AddGuppyScreen';
import ViewOrdersScreen  from './components/ViewOrdersScreen';
import GuppyDetails from './components/GuppyDetails';
import ChatScreen from './components/ChatScreen';
import AdminPage from './components/Mainadminchat';
import AddPlantScreen from './components/AddPlantScreen';
import AddAquariumScreen from './components/AddAquariumScreen'; 
import AddFoodScreen from './components/AddFoodScreen';
import AquariumDetails from './components/Aquarium-detailsScreen';
import StatsPage from './components/StatsPage';
import { PrivacyPolicy, TermsOfService, DataDeletion } from './components/LegalPages';
import AdminProtectedRoute from './components/AdminProtectedRoute';




const App = () => {
  useEffect(() => {
    // Initialize visitor tracking
    initializeTracking();
    
    // Track visit by wilaya (FREE - no Cloud Functions needed!)
    // This uses client-side IP geolocation and writes directly to Firestore
    trackWilayaVisit()
      .then((result) => {
        if (result.success) {
          console.log('✅ Wilaya visit tracked successfully:', result.wilaya);
        } else {
          console.log('ℹ️ Wilaya tracking:', result.message);
          // This is normal if visitor is not from Algeria or API is unavailable
        }
      })
      .catch((error) => {
        // Silently fail - don't interrupt user experience
        console.log('⚠️ Wilaya tracking error (non-critical):', error.message);
      });
  }, []);

  return (
    <Router>
      <RouteTracker />
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/OrdersPage" element={<OrdersPage />} />
        <Route path="/CategoryScreen" element={<CategoryScreen />} />
        <Route path="/guppy-details" element={<GuppyDetails />} />
        <Route path="/chat" element={<ChatScreen />} />
        <Route path="/aquarium-details" element={<AquariumDetails/>} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/data-deletion" element={<DataDeletion />} />

        {/* Protected Admin Routes */}
        <Route path="/AdminHomeScreen" element={<AdminProtectedRoute><AdminHomeScreen /></AdminProtectedRoute>} />
        <Route path="/AddGuppyScreen" element={<AdminProtectedRoute><AddGuppyScreen /></AdminProtectedRoute>} />
        <Route path="/ViewOrdersScreen" element={<AdminProtectedRoute><ViewOrdersScreen /></AdminProtectedRoute>} />
        <Route path="/admin/chat" element={<AdminProtectedRoute><AdminPage /></AdminProtectedRoute>} />
        <Route path="/admin/chatlist" element={<AdminProtectedRoute><AdminPage /></AdminProtectedRoute>} />
        <Route path="/admin/page" element={<AdminProtectedRoute><AdminPage /></AdminProtectedRoute>} />
        <Route path="/AddPlantScreen" element={<AdminProtectedRoute><AddPlantScreen /></AdminProtectedRoute>} />
        <Route path="/AddAquariumScreen" element={<AdminProtectedRoute><AddAquariumScreen /></AdminProtectedRoute>} />
        <Route path="/AddFoodScreen" element={<AdminProtectedRoute><AddFoodScreen /></AdminProtectedRoute>} />
        <Route path="/stats" element={<AdminProtectedRoute><StatsPage /></AdminProtectedRoute>} />
      </Routes>
    </Router>
  );
};
document.body.style.margin = '0';
document.body.style.padding = '0';

export default App;